import { Box, Card, Flex, Heading, Text } from "@radix-ui/themes";
import coach from '../img/avatars/coach1.png';
import { ReactComponent as Chart } from '../img/chart.svg';

interface ProfileDetailsProps {
  name?: string | null;
  email?: string | null;
  image?: string | null;
}

export default function ProfileDetails({ name, email, image }: ProfileDetailsProps) {
  return (
    <Card size="2" variant="classic" className="mb-5">
      <Flex align="center">
        <Box className="rounded-full size-20 overflow-hidden bg-zinc-300 flex-shrink-0">
          {image ? (
            <img
              src={coach}
              alt={name || "User"}
              width={80}
              className="object-cover"
            />
          ) : (
            <Box className="w-full h-full flex items-center justify-center text-3xl text-zinc-600">
              {name?.charAt(0).toUpperCase() || "U"}
            </Box>
          )}
        </Box>
        <Box ml="4">
          <Heading as="h2" size="6" mb="1">
            {name || "User"}
          </Heading>
          {email && (
            <Text as="p" size="2" color="gray">
              {email}
            </Text>
          )}
        </Box>
      </Flex>
      <Box className="mt-6">
        <Heading as="h3" size="3" className="border-b-1 border-gray-400">Competencies</Heading>
        <Box maxWidth={{ initial: "320", sm: "1024" }} maxHeight={{ initial: "320", sm: "1024" }}>
          <Chart width="inherit" />
        </Box>
      </Box>
    </Card>
  );
}
